import { Link } from 'react-router-dom';
import { ChevronRight, Link2, PlusCircle, Users, Users2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface Item {
  to: string;
  label: string;
  description: string;
  icon: typeof PlusCircle;
  iconBg: string;
  iconColor: string;
}

const items: Item[] = [
  {
    to: '/settings/devices/new',
    label: 'Adicionar Dispositivos',
    description: 'Cadastre novas máquinas (placa, modelo, ID único, foto)',
    icon: PlusCircle,
    iconBg: 'bg-status-running/10',
    iconColor: 'text-status-running',
  },
  {
    to: '/users',
    label: 'Usuários',
    description: 'Gerenciar usuários do sistema e suas permissões',
    icon: Users,
    iconBg: 'bg-primary/10',
    iconColor: 'text-primary',
  },
  {
    to: '/settings/clients',
    label: 'Clientes',
    description: 'Cadastro de clientes e vínculo com máquinas',
    icon: Users2,
    iconBg: 'bg-primary/10',
    iconColor: 'text-primary',
  },
  {
    to: '/settings/links',
    label: 'Vinculações',
    description: 'Vincular máquinas, clientes, notificações e geocercas a usuários',
    icon: Link2,
    iconBg: 'bg-status-ready/10',
    iconColor: 'text-status-ready',
  },
];

export function SettingsPage() {
  return (
    <div className="mx-auto max-w-2xl space-y-3 p-4 sm:p-6">
      <div>
        <h1 className="text-xl font-bold">Configurações</h1>
        <p className="text-sm text-muted-foreground">
          Cadastros e gerenciamento do ecossistema Fismatek.
        </p>
      </div>
      <Card>
        <CardContent className="p-0">
          <ul className="divide-y divide-border">
            {items.map((it) => (
              <li key={it.to}>
                <Link to={it.to} className="flex w-full items-center gap-3 px-4 py-3 hover:bg-accent">
                  <span
                    className={cn(
                      'flex h-10 w-10 shrink-0 items-center justify-center rounded-full',
                      it.iconBg,
                      it.iconColor,
                    )}
                  >
                    <it.icon className="h-5 w-5" />
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-semibold">{it.label}</p>
                    <p className="truncate text-xs text-muted-foreground">{it.description}</p>
                  </div>
                  <ChevronRight className="h-4 w-4 text-muted-foreground" />
                </Link>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
